import React from 'react';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { getPanels } from '_helpers';
import { AddButton } from '_components';
import {
    PatientCareCenterNoteObjectiveROMPanel,
    ROMHandTemplate
} from 'PatientCareCenter/Note/WorkProgram/Objective/ROM';

class PatientCareCenterNoteWpObjectiveROM extends React.Component {


    handleValueChange() {
        this.props.clearSpineFields(this.props.noteId);
    }

    updateValue(colName){
        this.props.updateDefaultObjWFL(this.props.noteType, colName, this.props.pk);
    }


    render() {
        return (
            <span>
                {(this.props.panels.length > 0) &&
                    <PatientCareCenterNoteSection id='obj_rom' name='Range of Motion' level={5}>
                        <div className={styles.row}>
                            <span className={styles.flag} />* indicates with pain
                        </div>
                        {this.props.panels.length > 0 && 
                            <span>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.rom_headers}>AROM</div>
                                    <div className={styles.prom_arom_spacer} />
                                    <div className={styles.rom_headers}>PROM</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.arom_r_header}>R</div>
                                    <div className={styles.arom_c_header} />
                                    <div className={styles.arom_l_header}>L</div>
                                    <div className={styles.prom_arom_spacer} />
                                    <div className={styles.prom_r_header}>R</div>
                                    <div className={styles.prom_c_header} />
                                    <div className={styles.prom_l_header}>L</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.arom_r_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMR')} /></div>
                                    <div className={styles.arom_c_header}>{this.props.hasCenterValues ? <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROM')} />: ""}</div>
                                    <div className={styles.arom_l_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROML')} /></div>
                                    <div className={styles.prom_arom_spacer} />
                                    <div className={styles.arom_r_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMR')} /></div>
                                    <div className={styles.arom_c_header}>{this.props.hasCenterValues ? <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROM')} />: ""}</div>
                                    <div className={styles.arom_l_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROML')} /></div>
                                </div>
                            </span>
                        } 
                        {
                            Object.keys(this.props.panels)
                                .map(key => {
                                    return (<PatientCareCenterNoteObjectiveROMPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} />);
                                })

                        }
                        {this.props.isHandSelected &&
                            <ROMHandTemplate />
                        }

                    </PatientCareCenterNoteSection>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearSpineFields: bindActionCreators(noteActions.clearSpineFields, dispatch),
        updateDefaultObjWFL: bindActionCreators(noteActions.updateDefaultObjWFL, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let panels = getPanels(noteId, 'ROM');
    let percentKeys = state.entities.masterData.PROPS['PTERO_SPINE_PERCENT_PANELS'].PRVALUE.split(',').map(Number);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;

    
    // filter out percentage panels
    panels = Object.keys(panels)
    .filter(key => {
        return !percentKeys.includes(panels[key].MOPNO);
    })
    .map(key => panels[key]);
    
    let hasCenterValues = panels.some(x => x.MOPMPTNO === 1);
    let isHandSelected = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 25) ||
                (noteType !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 25)
        }).length > 0 ? true : false;

    return {
        noteId,
        noteType,
        pk,
        rono,
        panels,
        isHandSelected,
        isWc,
        hasCenterValues
    };
}

const connectedPatientCareCenterNoteWpObjectiveROM = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpObjectiveROM);
export { connectedPatientCareCenterNoteWpObjectiveROM as PatientCareCenterNoteWpObjectiveROM };

